<template>
    <div class="newspaper_page_list">
        <div class="tab">
            <p class="table_head">
                版面导航
            </p>
            <table class="table">
                <tbody>
                    <tr v-for="(item,index) in pagesList">
                        <td class="title" @click="selectPage(item,index)">
                            {{item.edition+item.editionName}}
                        </td>
                        <td class="download" v-if="isInline">
                            <!-- <span @click="downloadFile(item.jpgPath,4)"><img src="../../../../public/image/downloadimg.png" alt=""></span> -->
                            <span @click="downloadFile(item.pdfPath,)"><img src="../../../../../public/image/downloadPdf.png" alt=""></span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    name: 'newspaperPageList',
    props: {
        pagesList: { //版面列表
            type: Array,
            required: true
        },
        isInline: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedPage: '', //被选中的版面
            selectedArr: [] //选中的版面集合
        };
    },
    mounted() {},
    methods: {
        /**
         * [selectPage description]选择版面
         * @param  {[type]} page [description]版面
         * @return {[type]}      [description]
         */
        selectPage(page, index) {
            this.$emit('update:curPage', page);
            this.$emit("choosePage");
            this.$emit('update:curPageIndex', index);
        },
        /**
         * [downloadFile description]文件下载
         * @param  {[type]} file [description]
         * @return {[type]}      [description]
         */
        downloadFile(filePath, type) {
            this.$downloadFile(filePath, type);
        }
    },
    computed: {}

}
</script>
<style scoped lang="less">
.newspaper_page_list {
    width: 100%;

    .tab {
        border: 1px solid rgba(235, 239, 242, 1);

        .table_head {
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(42, 42, 42, 1);
            background: rgba(249, 249, 249, 1);
            padding-left: 15px;
        }
    }

    table {
        width: 100%;
        padding-left: 15px;
        padding-top: 15px;
        padding-bottom: 15px;

        tr {
            cursor: pointer;
            height: 30px;
            td {
                border-top: none;
                vertical-align: middle;
            }

            .title {
                width: 290px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(62, 62, 62, 1);
                line-height: 20px;
            }

            .download {
                text-align: center;
                width: 1.5rem;

                span {
                    cursor: pointer;
                }
            }
        }
    }
}
</style>